import Icon from '../components/Icon'
import { mt } from '../lib/i18n'

/** The small "Resident" tag next to a neighbor's name. It only says their ID showed a Vieques address; never that they are safe. */
export default function ResidentTag(){
 return <span className="resident-tag"><Icon name="shield" size={12}/>{mt('residentTag')}</span>
}
